module.exports = __webpack_public_path__ + "img/bg.be9f2a10.png";